import React, { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";

export default function Faq() {
  const [faq, setFaq] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  let isMounted = true;
  const controller = new AbortController();

    window.scrollTo(0, 0);
    axios.get("api/home/faq",  { signal: controller.signal }).then((res) => {
      if (!isMounted) return;
      if (res.data.status == "success") {
        setFaq(res.data.data);
      } else {
        setFaq([]);
      }
      setLoading(false);
    }).catch(error => {
      if (!isMounted) return;
      if (error.name !== "AbortError" && error.name !== "CanceledError") {
        console.error("Failed to load FAQ data:", error);
      }
    });

    return () => {
      isMounted = false;
      setFaq([]);
      controller.abort();
    };
  }, []);
  const leftCol = [];
  const rightCol = [];
  faq.forEach((item, idx) => {
    if (idx % 2 === 0) {
      leftCol.push({ item, idx });
    } else {
      rightCol.push({ item, idx });
    }
  });

  return (
    <div className="section-full p-t30  p-b30 site-bg-light">


      <div className="container">
        <h2 className="text-center p-b50">Frequently Asked Questions</h2>
        <div className="tw-faq-section">
          <div className="row" id="sf-faq-accordion">
            <div className="col-md-6 col-sm-12">
              <div className="accordion tw-faq">
                {leftCol.length > 0
                  ? leftCol.map(({ item, idx }) => (
                      <div className="accordion-item" key={idx}>
                        <button
                          className={`accordion-button ${
                            idx == 0 ? "" : "collapsed"
                          }`}
                          type="button"
                          data-bs-toggle="collapse"
                          aria-expanded={` ${idx == 0 ? "true" : "false"}`}
                          data-bs-target={`#FAQ${idx}`}
                        >
                          {item.title}
                        </button>

                        <div
                          id={`FAQ${idx}`}
                          className={`accordion-collapse collapse ${
                            idx == 0 ? "show" : ""
                          }`}
                          data-bs-parent="#sf-faq-accordion"
                        >
                          <div className="accordion-body">
                            {ReactHtmlParser(item.description)}
                          </div>
                        </div>
                      </div>
                    ))
                  : ""}
              </div>
            </div>

            <div className="col-md-6 col-sm-12">
              <div className="accordion tw-faq">
                {rightCol.length > 0
                  ? rightCol.map(({ item, idx }) => (
                      <div className="accordion-item" key={idx}>
                        <button
                          className={`accordion-button ${
                            idx == 0 ? "" : "collapsed"
                          }`}
                          type="button"
                          data-bs-toggle="collapse"
                          aria-expanded={` ${idx == 0 ? "true" : "false"}`}
                          data-bs-target={`#FAQ${idx}`}
                        >
                          {item.title}
                        </button>

                        <div
                          id={`FAQ${idx}`}
                          className={`accordion-collapse collapse ${
                            idx == 0 ? "show" : ""
                          }`}
                          data-bs-parent="#sf-faq-accordion"
                        >
                          <div className="accordion-body">
                            {ReactHtmlParser(item.description)}
                          </div>
                        </div>
                      </div>
                    ))
                  : ""}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
